import React, { useState, useEffect } from "react";
import "./PreconferenceSpeaker.css";
import avatar from "../../Assets/avatar.jpg";

const PreconferenceSpeaker = () => {
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSpeakers = async () => {
      try {
        const response = await fetch(
          "https://api.dremerz.net/api/DZ_8922_Ampicon_Program_PreConference_SpeakersList"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch speakers");
        }
        const data = await response.json();
        setSpeakers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSpeakers();
  }, []);

  if (loading) {
    return (
      <div className="container">
        <h3 style={{ textAlign: "center" }} className="mt-4 mb-4">
          SPEAKERS
        </h3>
        <p>Loading speakers...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        <h3 style={{ textAlign: "center" }} className="mt-4 mb-4">
          SPEAKERS
        </h3>
        <p className="text-danger">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="container">
      <h3 style={{ textAlign: "center" }} className="mt-4 mb-4">
        SPEAKERS
      </h3>
      <div className="row">
        {speakers.map((speaker) => (
          <div key={speaker.id} className="col-md-6 mb-4">
            <div className="preconferenceSPEAKER-card d-flex align-items-center p-3">
              <img
                src={speaker.image ? `https://api.dremerz.net/uploads/${speaker.image}` : avatar}
                alt="Speaker"
                className="preconferenceSPEAKER-img me-4"
              />
              <div className="preconferenceSPEAKER-text">
                <h4 className="fw-bold text-dark">{speaker.name}</h4>
                <p
                  className="mb-1"
                  style={{ color: "#03a9f4", fontWeight: "500" }}
                >
                  {speaker.title}
                </p>
                <p className="text-secondary mb-0">{speaker.institution}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreconferenceSpeaker;